export default {
  retrievedUsers: (state, users) => {
    state.users = users;
  }
};
